export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [6],
		"/accident-by-driver": [7],
		"/accident-list": [8],
		"/acord-apps": [9],
		"/acord125": [10],
		"/additional-interest": [11],
		"/agency-admin": [12],
		"/agency-list": [13],
		"/applicant-info": [14],
		"/auto-liability": [15],
		"/auto-physical-damage": [16],
		"/brokerage-coverage": [17],
		"/brokerage-info": [18],
		"/campaign-designer": [19],
		"/campaign-manager": [20],
		"/captive-analysis": [21],
		"/cargo": [22],
		"/commodities-excess": [23],
		"/commodities-hauled": [24],
		"/commodities-info": [25],
		"/company-contacts": [26],
		"/company-strengths": [27],
		"/contract-owners": [28],
		"/customer": [29],
		"/cyber-security": [30],
		"/dashboard": [31],
		"/deductible-analysis": [32],
		"/driver-info": [33],
		"/drivers-list": [34],
		"/emails": [35],
		"/epic-integrations": [36],
		"/filings": [37],
		"/financials": [38],
		"/fmcsa-accident-analysis": [40],
		"/fmcsa": [39],
		"/freight-forwarding": [41],
		"/fuel-tax": [42],
		"/general-liability": [43],
		"/hired-auto": [44],
		"/import-everything": [45],
		"/import-fuel-tax": [46],
		"/import-loss-runs": [47],
		"/import-mvrs": [48],
		"/import-policy": [49],
		"/insurance-companies": [50],
		"/insurance-history": [51],
		"/landfill-supplemental": [52],
		"/lead-finder": [53],
		"/lienholder": [54],
		"/loss-stratification": [55],
		"/maintenance-info": [56],
		"/market-manager-captives": [57],
		"/market-manager-ic": [58],
		"/market-manager-mga": [59],
		"/mgas": [60],
		"/mileage-rev-pu": [61],
		"/monthly-reporting-exposures": [62],
		"/mvrs": [63],
		"/named-insured": [64],
		"/ncci-modifiers": [65],
		"/non-truckers": [66],
		"/operations-exposure": [67],
		"/operations-info": [68],
		"/payroll-history": [69],
		"/physical-locations": [70],
		"/producer-info": [71],
		"/profile": [72],
		"/public/pay-invoice/[token]": [73,[3]],
		"/public/unsubscribe/[token]": [74],
		"/radius-operations": [75],
		"/report-builder": [76],
		"/safety-info": [77],
		"/safety-materials": [78],
		"/(agency-modules)/sample-module": [5,[2]],
		"/single-cell-captive-analysis": [79],
		"/submission-builder": [80],
		"/system-admin": [81],
		"/tank-wash": [82],
		"/telematics": [83],
		"/trailer-interchange": [84],
		"/umbrella-excess": [85],
		"/vehicles-list": [86],
		"/waste-materials": [87],
		"/workers-comp": [88]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';